<template>
  <div class="col-12 col-md-12 col-lg-8">
    <div class="tit text-center">
      <h1>Para sua segurança, enviamos um código para o seu celular.</h1>
      <p>
        Enviamos para o número <strong>{{numeroCelular}}</strong> um código de 6 dígitos.
        <a href="" @click="showCellphoneField">(Trocar número)</a>
        </br>
        Preencha abaixo com o número recebido
      </p>
    </div>
    <div v-if="isCellphoneFieldVisible">
      <div>
        <div class="row justify-content-center">
          <div class="col-12 col-md-10 col-lg-8">
            <div class="form-group text-left">
              <label for="newCellphone" class="float-left">Telefone celular</label>
              <input :key="'newCellphoneField'" type="text" class="form-control form-control-lg" v-model="newCellphone" v-mask="'phone'" placeholder="Celular">
              <button class="btn btn-lg btn-primary float-right" @click="updateCellphone">Confirmar</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <form @submit="onSubmit">
        <div class="row justify-content-center">
          <div class="col-12 col-md-10 col-lg-8">
            <div class="form-group text-left" :class="isTokenValid == false ? 'invalid-field' : ''">
              <label for="" class="float-left">Código de confirmação</label>
              <input type="text" class="form-control form-control-lg token-field" v-model="tokenConfirmacao" maxlength="6" placeholder="Token de confirmação" @keyup="handleTokenKeyUp" required>
              <small class="validation-message">Token Inválido</small>
            </div>
            <div class="btns text-center">
              <a href="" class="btn btn-lg btn-link" @click="resendToken">SMS não chegou</a>
              <div class="text-center fixedOptions">
                <button class="btn btn-lg btn-primary" :disabled="!isTokenValid">Próximo</button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .resend-token-link {
    text-align: right;
  }

  .token-field {
    display: inline-block;
  }
</style>

<script>
import ApiClient from '@/utils/api-client'
import ApiClientGo from '@/utils/api-client-go'
 /* eslint-disable */
export default {
  data() {
    return {
      numeroCelular: this.solicitacao.Celular,
      newCellphone: this.solicitacao.Celular,
      tokenConfirmacao: null,
      isTokenValid: null,
      isCellphoneFieldVisible: false,
      sendSmsAttempt: 1
    }
  },
  props: {
    solicitacao: {required: true, type: Object}
  },
  methods: {
    showCellphoneField(e) {
      e.preventDefault()
      this.isCellphoneFieldVisible = true
    },
    updateCellphone() {
      
      ApiClient.put(`solicitacoes/${this.solicitacao._id}`, {data: {Celular: this.newCellphone}})
        .then(() => {
          console.log("Funcionou");
          this.numeroCelular = this.newCellphone
          this.isCellphoneFieldVisible = false
          this.$Message.info("Seu número foi atualizado")
        })
        .catch(() => {
          this.isCellphoneFieldVisible = false
          this.$Message.error("Houve um problema ao tentar atualizar o número")
        })
      
    },
    handleTokenKeyUp() {
      if(this.tokenConfirmacao.length == 6) {
        ApiClient.post('checar-token-sms', {data: {TokenConfirmacao: this.tokenConfirmacao, SolicitacaoId: this.solicitacao._id}})
          .then(() => {
            this.isTokenValid = true
          })
          .catch(() => {
            this.isTokenValid = false
          })
      } else {
        this.isTokenValid = null
      }
    },
    resendToken(e) {
      e.preventDefault()
      this.sendSmsAttempt += 1
      ApiClientGo.post('solicitacoes/gerar-token', {data: {solicitacaoId: this.solicitacao._id}})
        .then(() => {
          this.$Message.info("Um novo SMS foi enviado para o seu celular.")
        })
        .catch(() => {
          this.$Message.error("Houve um problema ao tentar enviar o SMS.")
        })
    },
    onSubmit(e) {
      e.preventDefault()
      this.$emit('on-submit', {
        TokenConfirmacao: this.tokenConfirmacao
      })
    }
  },
  created() {
    ApiClientGo.post('/solicitacoes/gerar-token', {data: {solicitacaoId: this.solicitacao._id}})
      .then(() => {
        this.$Message.info("Um novo SMS foi enviado para o seu celular.")
      })
      .catch(() => {
        this.$Message.error("Houve um problema ao tentar enviar o SMS.")
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AdditionalInformationPeerToPeer/ConfirmacaoTokenStep.vue